import Vue from 'vue'
import Vuex from 'vuex'
import application from './modules/application'
import getters from './getters'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
const store = new Vuex.Store({
    modules: {
        application
    },
    getters,
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
})

export default store